import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Collapse, TableCell, TableRow } from '@mui/material';

import { reverseFormatDate, todayDate } from '../../../../../utils/dateFunctions';

import InWorkSupportDetails from './InWorkSupportDetails';

import app from '../../../../../app.module.css';
import table from '../../../../../commonStyles/tables.module.css';

const dropdownStyles = {
    paddingBottom: 0,
    paddingTop: 0,
    paddingLeft: 0,
    paddingRight: 0,
    borderTop: 'none',
    borderBottom: 'none'
};

const textColours = {
    low: 'green',
    medium: 'amber',
    high: 'red'
};

const InWorkSupportTableRow = ({ row, toggleDropdown, openId, onOpenAddCallEditor }) => {
    const [open, setOpen] = useState(false);
    const [isDueToCall, setIsDueToCall] = useState(false);
    const [color, setColor] = useState('black');

    useEffect(() => {
        const isDue =
            todayDate() === row.dueDate.substring(0, 10) &&
            row.outcomeName.toLowerCase() !== 'contacted';
        setIsDueToCall(isDue);
        row?.workConfidenceName && setColor(textColours[row.workConfidenceName.toLowerCase()]);
    }, [row]);

    useEffect(() => {
        if (openId !== row.id) setOpen(null);
    }, [openId]);

    const onToggleDropdown = () => {
        toggleDropdown(row.id);
        setOpen(open === row.id ? null : row.id);
    };

    const onAddCall = () => onOpenAddCallEditor(true, row);

    return (
        <>
            <TableRow key={row.id} hover className={`${table.tableRowStripes} ${table.canOpen}`}>
                <TableCell
                    className={isDueToCall ? table.rowLink : table.nonLinkCell}
                    onClick={isDueToCall ? onAddCall : null}>
                    {reverseFormatDate(row.dueDate)}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>{`Week ${row.frequencyWeekNo}`}</TableCell>
                <TableCell onClick={onToggleDropdown}>
                    {row?.callDate ? reverseFormatDate(row.callDate) : '-'}
                </TableCell>
                <TableCell onClick={onToggleDropdown}>
                    <span className={app[color]}>{row.workConfidenceName || '-'}</span>
                </TableCell>
                <TableCell onClick={onToggleDropdown}>{row.outcomeName}</TableCell>
            </TableRow>
            <TableRow>
                <TableCell style={dropdownStyles} colSpan={5}>
                    <Collapse in={open === row.id} timeout="auto" unmountOnExit>
                        <InWorkSupportDetails row={row} onClose={() => setOpen(false)} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

InWorkSupportTableRow.propTypes = {
    row: PropTypes.object,
    toggleDropdown: PropTypes.func,
    openId: PropTypes.string,
    onOpenAddCallEditor: PropTypes.func
};

export default InWorkSupportTableRow;
